import React from 'react'

import { client } from 'config/routes'

import { HeaderLink } from './HeaderLink'

export const RecipeBoxesLink = () => <HeaderLink href={client.foodBox} text="recipe boxes" />
